import { FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useQuoteList } from "@/contexts/QuoteListContext";
import { cn } from "@/lib/utils";

type QuoteListButtonProps = {
  onClick: () => void;
  className?: string;
};

const QuoteListButton = ({ onClick, className }: QuoteListButtonProps) => {
  const { itemCount } = useQuoteList();

  return (
    <Button
      variant="outline"
      size="icon"
      onClick={onClick}
      className={cn("relative", className)}
      aria-label="Lista de cotización"
    >
      <FileText className="h-5 w-5" />
      {itemCount > 0 && (
        <Badge
          className="absolute -top-2 -right-2 h-6 w-6 flex items-center justify-center p-0 bg-primary text-primary-foreground"
          variant="default"
        >
          {itemCount > 9 ? "9+" : itemCount}
        </Badge>
      )}
    </Button>
  );
};

export default QuoteListButton;
